(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowResponseLoop', drvWorkflowResponseLoop);

    drvWorkflowResponseLoop.$inject = ['$q', 'WorkflowRunService', 'DialogService'];
    
    function drvWorkflowResponseLoop($q, WorkflowRunService, DialogService) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: true,
            templateUrl: 'app/workflow/responses/workflow-response-loop.tmpl.html'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.disabled = false;

            scope.$watch(function () { return scope.step.Properties; }, function (newVal, oldVal) {
                if (angular.isDefined(newVal) && newVal !== null) {
                    scope.questionOptions = newVal.Choices.split('|');
                } else {
                    scope.questionOptions = [];
                }
            });

            scope.respond = function (responseValue) {
                scope.disabled = true;
                return WorkflowRunService.respondToStep(scope.instanceId, scope.step.StepId, responseValue)
                    .catch(function (response) {
                        DialogService.error('Error responding to Workflow step', response);
                        return $q.reject(response);
                    });
            };
        }
    }
})();